<template>

  <div class="menu" v-show="show" @mouseleave="close">
    <div class="menu-item" :class="{disabled: item.status > 2}"  v-if="type == 1" @click="!(item.status > 2) ? changeStatus(3) : ''">
      Предзаказ
    </div>
    <div class="menu-item" :class="{disabled: item.status > 3}"  v-if="type == 1" @click="!(item.status > 3) ? $emit('entityModal', item) : ''">
      Отправить в 1С на оформление
    </div>
    <div class="menu-item" :class="{disabled: item.status > 3}" v-if="!item.dropshipping" @click="!(item.status > 3) ? $emit('ordersModal', item) : ''">
      Объединить заказы
    </div>
    <!--<div class="menu-item" :class="{disabled: item.status > 4}"  v-if="type == 1" @click="!(item.status > 4) ? changeStatus(5) : ''">
      Выставлен счет
    </div>-->
    <div class="menu-item" :class="{disabled: item.status > 5}"  v-if="type == 1" @click="!(item.status > 5) ? changeStatus(6) : ''">
      Отправлен
    </div>
    <div class="menu-item" v-if="type == 2 && !item.contract" :class="{disabled: item.status > 0}" @click.prevent="!(item.status > 0 ) ? contract() : ''">
      Заключить договор
    </div>
    <div class="menu-item"  v-if="type == 2" :class="{disabled: item.status > 6 || item.status == 0 || item.status < 4}" @click="!(item.status > 6 || item.status == 0 || item.status < 4) ? changeStatus(7) :''">
      Принят
    </div>
    <div class="menu-item" v-if="type == 2" :class="{disabled: item.status > 7 || item.status == 0 || item.status < 4}" @click="!(item.status > 7 || item.status == 0 || item.status < 4) ?changeStatus(8) : ''">
      Рекламации при приемке
    </div>
    <div class="menu-item" :class="{disabled: item.status > 4}" @click="!(item.status > 4) ? $emit('setCancelParams', item.id) : ''">
      Отменить
    </div>
    <div class="menu-item" v-if="type == 2" :class="{disabled : false}" @click="copyOrder(item.id)">
      Дублировать заказ
    </div>
    <!--<div class="menu-item" v-if="type == 1" @click="xml()">
      Отправить в 1С на оформление
    </div>-->
  </div>
</template>

<script>

export default {
  name: "order-menu",
  props: {
    item: {
      type: [Object,Array],
      default: null
    },
    canChange: {
      type: Boolean,
      default: null
    },
    type:{
      type: Number,
      default: 1
    },
  },
  created () {
    if(this.item == null) console.trace (`%c [order-menu]item is not selected to menu`, 'background: #222; color: #bada55')
  },
  data: () => ({
    show: false
  }),
  methods: {
    copyOrder(id){
      if (localStorage.getItem('token')) {
        this.$http.post('create-double-order', {
          token: localStorage.getItem('token'),
          order_id: id
        }).then(({data}) => {
          if (data.success) {
            this.$emit('saved');
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    open(){
      if(this.item == null) return 0;
      this.show = true;
    },
    close(){
      this.show = false;
    },
    contract() {
      this.$emit('contract', this.item.provider_id);
    },
    changeStatus(val) {
      if (localStorage.getItem('token')) {
        this.$http.post('/change-order-status', {
          token: localStorage.getItem('token'),
          id: this.item.id,
          status: val
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Статус успешно изменен!');
            this.item.status = val;
            this.$emit('saved');
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    }
    /*xml () {
      if (localStorage.getItem('token')) {
        this.$http.post('/order-xml', {
          token: localStorage.getItem('token'),
          id: this.item.id
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Заказ отправлен в 1С');
            this.$emit('saved');
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    }*/
  }
}
</script>

<style scoped lang="scss">

.menu{
  right: 69px;
  margin-top: 14px;
  position: absolute;
  width: calc(380% + 20px);
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 0px 30px rgba(129, 129, 129, 0.25);
  padding: 17px 0;
  z-index: 2;
  bottom: 0px;

  &-item{
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    cursor: pointer;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #7A818F;
    padding: 5px 17px;

    &:hover{
      background-color: rgba(0, 0, 0, .05);
    }
    &.disabled,:hover{
      background-color: unset;
      cursor: unset;
      opacity: .3;
    }

    &.orange{
      color: #F39220;
    }

    &.green{
      color: #2CB181;
    }
  }
}
</style>
